import { render, staticRenderFns } from "./CardCliente.vue?vue&type=template&id=05dd36e2&scoped=true"
import script from "./CardCliente.vue?vue&type=script&lang=js"
export * from "./CardCliente.vue?vue&type=script&lang=js"
import style0 from "./CardCliente.vue?vue&type=style&index=0&id=05dd36e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd36e2",
  null
  
)

export default component.exports